export default class CheckoutPage {
    constructor() {
        window.addEventListener('load', () => {});
    }
}
